export interface VideoRecording {
  id: string;
  user_id: string;
  title: string;
  description: string | null;
  storage_path: string;
  thumbnail_path: string | null;
  subtitle_path?: string | null;
  duration_seconds: number | null;
  created_at: string;
  updated_at: string;
  is_public: boolean;
  is_deleted: boolean;
  view_count: number;
  metadata: RecordingMetadata;
}

export interface RecordingMetadata {
  width?: number;
  height?: number;
  hasAudio?: boolean;
  hasVideo?: boolean;
  hasCameraVideo?: boolean;
  hasScreenVideo?: boolean;
  fileSize?: number;
  tags?: string[];
  [key: string]: any;
}

export interface VideoShare {
  id: string;
  video_id: string;
  owner_id: string;
  shared_with_email: string | null;
  shared_with_user_id: string | null;
  access_type: 'view' | 'edit';
  share_token: string;
  created_at: string;
  expires_at: string | null;
  is_active: boolean;
}

export interface RecordingState {
  isRecording: boolean;
  isPaused: boolean;
  elapsedTimeSeconds: number;
  recordingType: RecordingType | null;
  audioEnabled: boolean;
  error: string | null;
  message: string | null;
}

export interface VideoComment {
  id: string;
  video_id: string;
  user_id: string;
  comment: string;
  timestamp_seconds: number | null;
  created_at: string;
  updated_at: string;
  is_deleted: boolean;
  parent_comment_id: string | null;
  // Client-side only properties
  user_name?: string;
  user_avatar?: string;
}

export interface RecordingOptions {
  audio: boolean;
  video: boolean;
  screen: boolean;
  camera: boolean;
  maxDurationSeconds?: number;
}

export enum RecordingType {
  SCREEN = 'screen',
  CAMERA = 'camera',
  BOTH = 'both'
}

export enum ProcessingStatus {
  UPLOADING = 'uploading',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed'
}

export interface VideoUploadProgress {
  status: ProcessingStatus;
  progress: number;
  message: string;
  videoId?: string;
  error?: string;
}
